import React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { ISetSearchParams } from 'components/core/types'
import { AppDispatch } from 'components/store/state/store'
import { IApplicationState } from 'components/store/types'
import { getActiveView, getCurrentRegion, getCurrentTreatmentId } from 'components/core/state/selectors'
import Container from 'components/ui/Container'
import Step2Filters from 'components/steps/Step2Filters'
import { updateCurrentStep } from 'components/core/state/actions'
import useResponsive from 'hooks/useResponsive'
import Step2MapDesktop from 'components/steps/Step2MapDesktop'
import Step2MapMobile from 'components/steps/Step2MapMobile'
import CliniquesSliderContainer from 'components/ui/CliniquesSliderContainer'

const mapState = (state: IApplicationState) => ({
  activeView: getActiveView(state),
  region: getCurrentRegion(state),
  treatment: getCurrentTreatmentId(state),
})
const mapDispatch = (dispatch: AppDispatch) => ({
  updateStep: (step: number, setSearchParams: ISetSearchParams) => {
    dispatch(updateCurrentStep(step, setSearchParams))
  },
})

const connector = connect(mapState, mapDispatch)

const Step2 = ({
  activeView,
  region,
  treatment,
  updateStep,
}: ConnectedProps<typeof connector>) => {
  const [, setSearchParams] = useSearchParams()
  if (!region || !treatment) {
    updateStep(1, setSearchParams)
  }
  const { compareTag } = useResponsive()
  let Component
  switch (activeView) {
    case 'cards':
      Component = CliniquesSliderContainer
      break
    case 'map':
    default:
      Component = compareTag('lg') ? Step2MapDesktop : Step2MapMobile
      break
  }
  return (
    <Container>
      <div className="tw-col-span-12">
        <Step2Filters />
        <Component />
      </div>
    </Container>
  )
}
export default connector(Step2)
